/**
 * Extracts the teamsId and channelId from a Microsoft Teams link.
 * @param teamsLink
 * @returns
 */
export const extractTeamsData = (teamsLink: string) => {
  try {
    const url = new URL(teamsLink);
    const params = new URLSearchParams(url.search);

    // Extract teamsId from the 'groupId' query parameter
    const teamsId = params.get('groupId');

    // Extract channelId from the path (after '/l/channel/')
    const match = url.pathname.match(/\/l\/channel\/([^/]+)/);
    const channelId = match?.[1] ?? undefined;

    return { teamsId, channelId };
  } catch {
    return { teamsId: undefined, channelId: undefined };
  }
};
